import { useParams } from 'react-router-dom';
import api from '../../services/api';
import { useMutation, useQuery} from "@tanstack/react-query";
import { error } from "../global/ToastAlert";
import { useEffect, useState } from 'react';

export const useGetVendor = () => {
    const { vendorId, vSlug } = useParams();
    
    const fetchData = async () => {
        if (vendorId) {
            // Fetch vendor by ID
            const { data } = await api.get(`/vendors/${vendorId}/?vendorId=${vendorId}`);
            return data;
        } else if (vSlug) {
            // Fetch vendor by Slug
            const { data } = await api.get(`/vendors/slug/${vSlug}/?slug=${vSlug}`);
            return data;
        }
        return null;
    };

    return useQuery({ 
        queryKey: ['vendor', vendorId || vSlug], 
        queryFn: fetchData, 
        enabled: !!vendorId || !!vSlug, 
        refetchOnWindowFocus: false 
    });
}


export const useCheckCodeVendor = () => {
    const { vendorId: paramVendorId } = useParams();
    const { data: vendorData, isLoading } = useGetVendor(); // Get vendor details
    const [params, setParams] = useState(null);

    // Determine vendorId (either from params or fetched from API)
    const vendorId = paramVendorId || vendorData?.id;

    const checkCode = async ({ data: code, message = null }) => {
        setParams({ data: code, message }); // Store params safely

        if (isLoading && !vendorId) return; // Wait until vendorId is available

        const { data } = await api.post(`/vendors/${vendorId}/codes/?vendorId=${vendorId}`, code);
        if (data && data.code.length === 0) error(message, 3000, "bottom-center");
        return data;
    };

    const mutation = useMutation(checkCode);

    useEffect(() => {
        if (vendorData && !paramVendorId) {
            mutation.mutate(params);
        }
    }, [vendorData]); 

    return mutation;
};


export const useCheckCodeProduct = () => {
    const { vendorId: paramVendorId} = useParams();
    const { data: vendorData, isLoading } = useGetVendor(); // Get vendor details
    const [params, setParams] = useState(null);

    // Determine vendorId (either from params or fetched from API)
    const vendorId = paramVendorId || vendorData?.id;
    const checkCode = async ({data:code, message=null}) => {
        setParams({ data: code, message });
        if (isLoading && !vendorId) return; // Wait until vendorId is available
        const { data } = await api.post(`/vendors/${vendorId}/source/?vendorId=${vendorId}`, code);
        if(data && data.code.length === 0 ) error(message, 3000, 'bottom-center');
        return data;
    };
    const mutation = useMutation(checkCode);

    useEffect(() => {
        if (vendorData && !paramVendorId)  mutation.mutate(params);
    }, [vendorData])


    return mutation;
};